import React from 'react';
import { Button } from './ui/Button';
export function TestimonialsSection() {
  return <section className="py-10 bg-alt border-y border-[#D9D0C1]" data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="text-center mb-10" data-id="element-204">
          <h2 className="text-3xl md:text-4xl font-serif text-title mb-4" data-id="element-205">
            Mujeres reales. Sin exposición.
          </h2>
          <p className="text-body" data-id="element-206">
            Privacidad primero. Método paso a paso para publicar sin mostrar tu
            cara.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-207">
          {/* Testimonial 1 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-208">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-209">
              "Antes me frenaba el miedo a que me reconocieran. Ahora publico
              con una cuenta anónima sin ansiedad. Lo que cambió fue tener una
              estructura clara para saber qué subir y cuándo."
            </p>
            <div className="flex items-center" data-id="element-210">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 flex items-center justify-center font-serif text-accent text-lg" data-id="element-211">
                L
              </div>
              <div data-id="element-212">
                <p className="font-medium text-title text-sm" data-id="element-213">Laura</p>
                <p className="text-xs text-body" data-id="element-214">Madrid · +30 · oficina</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-215">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-216">
              "La cámara me bloqueaba y lo dejaba siempre para «mañana». Con el
              método empecé a publicar sin exponerme. Tener pasos y plantillas
              me quitó la presión de improvisar."
            </p>
            <div className="flex items-center" data-id="element-217">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 flex items-center justify-center font-serif text-accent text-lg" data-id="element-218">
                C
              </div>
              <div data-id="element-219">
                <p className="font-medium text-title text-sm" data-id="element-220">Carmen</p>
                <p className="text-xs text-body" data-id="element-221">Valencia · introvertida</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-card p-8 border-l-2 border-accent" data-id="element-222">
            <p className="text-body italic mb-6 text-sm leading-relaxed" data-id="element-223">
              "No es un curso vendehumo. Es una guía práctica con pasos claros.
              Empecé a publicar la primera semana sin mostrar mi cara ni
              inventar nada."
            </p>
            <div className="flex items-center" data-id="element-224">
              <div className="w-10 h-10 bg-[#E7D8C8] rounded-full mr-3 flex items-center justify-center font-serif text-accent text-lg" data-id="element-225">
                E
              </div>
              <div data-id="element-226">
                <p className="font-medium text-title text-sm" data-id="element-227">Elena</p>
                <p className="text-xs text-body" data-id="element-228">España · poco tiempo</p>
              </div>
            </div>
          </div>
        </div>

        {/* Trust Micro-row */}
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mt-10 text-sm text-body" data-id="element-229">
          <span data-id="element-230">✦ Sin cámara</span>
          <span data-id="element-231">✦ Sin nombre real</span>
          <span data-id="element-232">✦ Con estructura (pasos + plantillas)</span>
        </div>

        {/* CTA #3 */}
        <div className="text-center mt-10" data-id="element-233">
          <Button size="lg" withArrow data-id="element-234">
            Lo quiero
          </Button>
          <p className="text-xs text-body mt-3" data-id="element-235">
            Acceso inmediato · Garantía 14 días
          </p>
        </div>
      </div>
    </section>;
}